import React, { useEffect, useRef, useState } from "react";
import styles from "./Vcomp.module.css";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import ProjectCard from "../../components/vcomp/projectCard";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import CreateProjectModal from "../../components/vcomp/createProjectModal";
import CreateProjectModalMobile from "../../components/vcomp/createProjectModalMobile";
import { setAdminConfigModal, setCreateProjectModalVisible, setSelectedView } from "../../components/vcomp/vcompSlice";
import { checkPermission, isAdmin, isOwner } from "../../app/utils/helpers";
import { config } from "../../app/utils/config";
import { getProjects } from "../../components/vcomp/vcompSlice";
import { ViewSelectButton } from "../../components/buttons/ViewSelectButton";
import configIcon from "../../assets/images/configIconOrange.png";
import configIconFocus from "../../assets/images/configIconOrangeFill.png"
import AdminFormConfig from "../../components/vcomp/AdminFormConfig";
import MobileAdminFormConfig from "../../components/vcomp/MobileAdminFormConfig";
import CollabProjectForm from "../../components/vcomp/CollabProjectForm";
import MobileCollabProjectForm from "../../components/vcomp/MobileCollabProjectForm";
import { InputText } from "primereact/inputtext";
import CollabMcqView from "../../components/vcomp/CollabMcqView";
import MobileCollabMcqView from "../../components/vcomp/MobileCollabMcqView";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useNavigate, useParams } from "react-router-dom";
import MobileVcompTopMenu from "./mobile/MobileVcompTopMenu";
import MobileVcompProjectsList from "./mobile/MobileVcompProjectsList";

export default function VcompView() {

    const mounted = useRef(null)
    const dispatch = useDispatch()


    const urlParams = useParams()
    const navigate = useNavigate()
    const isMobile = useSelector((state) => state.settings.isMobile);
    const projectsList = useSelector((state) => state.vcomp.projectsList);
    const selectedView = useSelector((state) => state.vcomp.selectedView);
    const userRoleId = useSelector((state) => state.login.userRoleId);
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)


    const [manFilter, setManFilter] = useState('')
    const [colFilter, setColFilter] = useState('')

    const [iManageProjects, setIManageProjects] = useState([])
    const [iParticipateProjects, setIParticipateProjects] = useState([])

    const [viewsOptions, setViewOptions] = useState([
        { label: <Langs str='Participate' />, value: 0 },
        { label: <Langs str='Manage' />, value: 1 }
    ])
    useEffect(() => {
        if (urlParams.subView && viewsOptions[urlParams.subView]) {
            setSelectedView(urlParams.subView)
        }
    }, [urlParams])

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getProjects())
            mounted.current = true
        }
    }, [dispatch])

    useEffect(() => {
        setIManageProjects(projectsList.filter((project) => project.isManager == 1))
        setIParticipateProjects(projectsList.filter((project) => project.isCollab == 1))
    }, [projectsList])



    const handleViewChange = (view) => {
        if (view != null) {
            let selectedTeamId = selectedTeamsIds[0]
            navigate(`/vcomp/${selectedTeamId}/${view}`)
            dispatch(setSelectedView(view))
        }
    }
    useEffect(() => {
        if (urlParams.view == 'vcomp' && urlParams.subView == '0' && urlParams.label) {
            setColFilter(prev => {
                return urlParams.label.trim()
            })
            dispatch(setSelectedView(urlParams.subView))
        } else if (urlParams.view == 'vcomp' && urlParams.subView == '1' && urlParams.label) {
            setManFilter(prev => {
                return urlParams.label.trim()
            })
            dispatch(setSelectedView(urlParams.subView))
        }
    }, [urlParams])

    const body = () => {
        return (
            <div className={`d-flex justify-content-center pt-4 ${styles.collabsCard} ${isMobile === 2 ? styles.mobileBody : ''}`} >
                {selectedView == 0 &&
                    <Row className={`d-flex justify-content-start ${styles.projectsRow}`} style={{ width: "92%", height: "40vh" }}>
                        <Col className="ps-3 pb-1" xs={12}>
                            <InputText placeholder="Rechercher..." value={colFilter} onChange={(e) => setColFilter(e.target.value)} style={{ height: "40px", width: "300px" }} />
                        </Col>
                        {iParticipateProjects.filter(p => p.active === 1 && p.nom.toLowerCase().includes(colFilter.toLowerCase())).map((p) => {
                            return (p.active === 1 &&
                                <ProjectCard project={p} />
                            )
                        })}
                    </Row>
                }
                {selectedView == 1 &&
                    <Row className={`d-flex justify-content-start ${styles.projectsRow}`} style={{ width: "92%", height: "40vh" }}>
                        <Col className="ps-3 pb-1" xs={12}>
                            <InputText placeholder="Rechercher..." value={manFilter} onChange={(e) => setManFilter(e.target.value)} style={{ height: "40px", width: "300px" }} />
                        </Col>
                        {iManageProjects.filter(p => (p.active === 1 || isOwner(userRoleId)) && p.nom.toLowerCase().includes(manFilter.toLowerCase())).map((p) => {
                            return <ProjectCard project={p} manage={true} />
                        })}
                    </Row>
                }
            </div>
        )
    }

    const mobileFilteredProjects = () => {
        if (selectedView == 0) {
            return iParticipateProjects.filter(p => p.active === 1 && p.nom.toLowerCase().includes(colFilter.toLowerCase()));
        }
        return iManageProjects.filter(p => (p.active === 1 || isOwner(userRoleId)) && p.nom.toLowerCase().includes(manFilter.toLowerCase()));
    };

    if (isMobile === 2) {
        return (
            <div>
                <MobileVcompTopMenu
                    selectedView={selectedView}
                    viewsOptions={checkPermission(config.scopes.vcomp, config.permissionTypes.edit) ? viewsOptions : []}
                    onViewChange={handleViewChange}
                    showConfigButton={selectedView == 1 && isOwner(userRoleId)}
                    showAddButton={selectedView == 1 && checkPermission(config.scopes.vcomp, config.permissionTypes.edit)}
                    onConfigClick={() => dispatch(setAdminConfigModal(true))}
                    onAddClick={() => dispatch(setCreateProjectModalVisible(true))}
                />
                <MobileVcompProjectsList
                    projects={mobileFilteredProjects()}
                    manage={selectedView == 1}
                    filter={selectedView == 0 ? colFilter : manFilter}
                    onFilterChange={(val) => selectedView == 0 ? setColFilter(val) : setManFilter(val)}
                />
                <CreateProjectModalMobile />
                <MobileAdminFormConfig />
                <MobileCollabProjectForm />
                <MobileCollabMcqView />
            </div>
        );
    }

    return (
        <div>
            <div>
                <div className="topMenu" style={{ height: 'auto' }}>
                    <Row>
                        <Col lg={4} xs={12}>
                            <span className="headerTitle">
                                {<Langs str="V-Comp" />}
                            </span>
                        </Col>
                        <Col lg={4} xs={9}
                            className={(isMobile == 1 || isMobile == 3) ? "d-flex justify-content-center " : "d-flex justify-content-start mt-2"}>
                            {checkPermission(config.scopes.vcomp, config.permissionTypes.edit) &&
                                <ViewSelectButton
                                    options={viewsOptions}
                                    selectedView={viewsOptions[selectedView].value}
                                    onViewChange={handleViewChange}
                                />
                            }
                        </Col>
                        {selectedView == 1 && <Col lg={4} xs={3} className={(isMobile == 1 || isMobile == 3) ? "d-flex justify-content-end pe-4 align-items-end p-0 m-0" : "d-flex justify-content-end px-2 align-items-center p-0 m-0 mt-2"}>
                            {isOwner(userRoleId) &&
                                <ImageButton
                                    image={configIcon}
                                    imageFocus={configIconFocus}
                                    width={32}
                                    active={true}
                                    onClick={() => { dispatch(setAdminConfigModal(true)) }}
                                />
                            }
                            {checkPermission(config.scopes.vcomp, config.permissionTypes.edit) &&
                                <ImageButton
                                    image={addIcon}
                                    imageFocus={addIconFocus}
                                    width={32}
                                    active={true}
                                    onClick={() => { dispatch(setCreateProjectModalVisible(true)) }}
                                />
                            }
                        </Col>}
                    </Row>
                </div>
                {body()}
                <CreateProjectModal />
                <AdminFormConfig />
                <CollabProjectForm />
                <CollabMcqView />
            </div>
        </div>
    )
}